import useFetchMultiplePayments from '../../../core/apiHooks/useFetchMultiplePayments';
import useDealerProvincePricing from '../../../utils/hooks/useDealerProvincePricing';
import { useAppSelector } from '../../../core/utils';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
export const getPaymentByRecommendedVehicle = (vehicle, payments) => payments === null || payments === void 0 ? void 0 : payments.find(payment => {
    const { detKeys } = payment || {};
    const { exteriorColorKey, interiorColorKey, modelKey, modelYear, transmissionKey, trimKey } = detKeys || {};
    return (modelKey === vehicle.modelKey &&
        modelYear === vehicle.modelYear &&
        trimKey === vehicle.trimKey &&
        transmissionKey === (vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmissionKey) &&
        exteriorColorKey === (vehicle === null || vehicle === void 0 ? void 0 : vehicle.exteriorColorKey) &&
        interiorColorKey === (vehicle === null || vehicle === void 0 ? void 0 : vehicle.interiorColorKey));
});
const usePaymentData = (recommendedVehicles = [], shouldFetch = true) => {
    const paymentRequests = recommendedVehicles.map(vehicle => ({
        modelKey: vehicle.modelKey,
        modelYear: vehicle.modelYear,
        trimKey: vehicle.trimKey,
        transmissionKey: vehicle.transmissionKey,
        exteriorColorKey: vehicle.exteriorColorKey,
        interiorColorKey: vehicle.interiorColorKey,
        accessories: [],
        protections: [],
        protectionAddOns: [],
    }));
    const { dealerProvinceCode, isSellingPriceProvince } = useDealerProvincePricing();
    const primaryCalculatorPaymentOptions = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    // set flag based on dealer province
    const customPaymentOptions = {
        ...primaryCalculatorPaymentOptions,
        overriddenIsSellingProvince: isSellingPriceProvince,
    };
    const paymentResponse = useFetchMultiplePayments(paymentRequests, recommendedVehicles.length > 0 && shouldFetch, Array(paymentRequests.length).fill(customPaymentOptions), undefined, dealerProvinceCode);
    const recommendedVehiclesWithPaymentData = recommendedVehicles.map(vehicle => {
        const paymentData = getPaymentByRecommendedVehicle(vehicle, paymentResponse.data);
        return {
            ...vehicle,
            paymentData: {
                data: paymentData,
                error: paymentResponse.error,
                isFetching: paymentResponse.isFetching,
                isLoading: paymentResponse.isLoading,
            },
        };
    });
    return recommendedVehiclesWithPaymentData;
};
export default usePaymentData;
